export default __webpack_public_path__ + "static/media/marines-share.64ca9c3d.jpg";